"use strict";
/// <reference path="../../../../Trillium.UI/TypeScript/Models/Website/DownloadLinkComponentViewModel.tsx"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var DownloadLinkItemComponent = /** @class */ (function (_super) {
    __extends(DownloadLinkItemComponent, _super);
    function DownloadLinkItemComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DownloadLinkItemComponent.prototype.render = function () {
        var downloadLabel = this.props.DownloadLabel;
        var label;
        if (downloadLabel === "" || downloadLabel === "undefined") {
            label = "Download";
        }
        else {
            label = downloadLabel;
        }
        return (react_1.default.createElement("article", { id: "downloadLink_" + this.props.UniqueKey, className: "list-group-item download ptb-20 col-md-12 col-sm-12" },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "col-sm-9" },
                    react_1.default.createElement("a", { href: this.props.LinkUrl }, this.props.LinkTitle)),
                react_1.default.createElement("div", { className: "col-sm-3 download-section-div" },
                    react_1.default.createElement("div", { className: "download-section" },
                        react_1.default.createElement("a", { href: this.props.LinkUrl, className: "download" },
                            label,
                            react_1.default.createElement("i", { className: "fas fa-download download-icon", "aria-hidden": "true" })))))));
    };
    return DownloadLinkItemComponent;
}(react_1.Component));
exports.default = DownloadLinkItemComponent;
